module.exports = __webpack_public_path__ + "img/banner-medis-mobile.2fd02129.jpeg";